module.exports = __webpack_public_path__ + "img/1.db116fc2.svg";